import React from 'react';
import SelectField from '../../../../Components/Form/components/SelectField';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import CSSZAddressContainer from '../CSSZSickLeaveCertificateCreate/FormParts/CSSZAddressContainer';
import { CSSZAddress } from '../../Interfaces/CSSZ.interface';
import { DeepPartial } from '../../../../Interfaces/DeepPartial';
import { CSSZSickLeaveValues } from '../CSSZSickLeaveCertificateCreate/CSSZSickLeaveCertificateCreate';
import { yupResolver } from '@hookform/resolvers/yup';
import { CSSZSickLeavePatientAddressValidationScheme } from '../../Validation/CSSZValidation';
import TermItemAsyncSelectField from '../../../Base/Components/Fields/TermItemAsyncSelect/TermItemAsyncSelectField';
import { useDisclose } from '../../../Modal/Hooks/useDisclose';
import CSSZSickLeavePatientAddressesPickerModal from '../CSSZSickLeavePatientAddressesPicker/CSSZSickLeavePatientAddressesPickerModal';
import { useLazyTermItemByValueQuery } from '../../../../graphql/graphql';
import {
	CsszPatientAddressRow,
	mapCsszRegistryAddressRowToPatientFormFields,
} from '../../Helpers/csszRegistryPatientAddresses.helper';

interface Props {
	userId: string;
	onSubmit: (values: CSSZAddress) => void;
	collectedValues?: DeepPartial<CSSZSickLeaveValues>;
}

const TYPE_OF_ADDRESS: SelectValue[] = [
	{
		label: 'Trvalý pobyt',
		value: 'permanentStay',
	},
	{
		label: 'Přechodný pobyt',
		value: 'temporaryStay',
	},
];

const CSSZSickLeavePatientAddressForm: React.FC<Props> = ({
	userId,
	onSubmit,
	collectedValues,
}) => {
	const { isOpen, onClose: onClosePicker } = useDisclose(true);
	const [getTermItemByValue] = useLazyTermItemByValueQuery();

	const formMethods = useForm({
		defaultValues: collectedValues?.patientAddress,
		resolver: yupResolver(CSSZSickLeavePatientAddressValidationScheme),
	});

	const handleSelectRegistryRow = async (item: CsszPatientAddressRow) => {
		const { fields, countryCode } =
			mapCsszRegistryAddressRowToPatientFormFields(item);

		const state = countryCode
			? await getTermItemByValue({
					value: countryCode,
					termType: 'cssz_ciselnik_zemi',
			  })
			: null;

		const stateOption = state?.data?.termItem
			? {
					label: state.data.termItem.name,
					value: state.data.termItem.value,
			  }
			: undefined;

		formMethods.reset({
			...collectedValues?.patientAddress,
			...fields,
			state: stateOption ?? fields.state,
		});
		onClosePicker();
	};

	return (
		<>
			<FormWrapper formMethods={formMethods}>
				<div className='row'>
					<div className='col-6'>
						<SelectField
							name='typeOfAddress'
							options={TYPE_OF_ADDRESS}
							label='component.CSSZSickLeavePatientAddress.typeOfAddress'
							isWrapped
						/>
					</div>
					<div className='col-6'>
						<TermItemAsyncSelectField
							name='state'
							label='component.CSSZSickLeavePatientAddress.state'
							termType='cssz_ciselnik_zemi'
							isRequired
							isWrapped
						/>
					</div>
				</div>
				<CSSZAddressContainer />
				<div className='mt-3'>
					<SubmitButton
						title='component.CSSZSickLeavePatientAddress.save'
						onSubmit={onSubmit}
					/>
				</div>
			</FormWrapper>
			{isOpen && (
				<CSSZSickLeavePatientAddressesPickerModal
					isOpen
					userId={userId}
					onClose={onClosePicker}
					onSelect={handleSelectRegistryRow}
				/>
			)}
		</>
	);
};

export default CSSZSickLeavePatientAddressForm;
